import type { ITourStep, TourDirection } from './types';

/**
 * An `onLeave` that closes what an action step opened when the tour leaves in
 * ONE direction: Back from the first step inside a dialog or drawer returns
 * to the button that opened it, and Next from the last step reads "Close the
 * form" and does exactly that.
 */
export const closeOnLeave = <C>(direction: TourDirection, close: (ctx: C) => void): NonNullable<ITourStep<C>['onLeave']> =>
  (ctx, left) => { if (left === direction) close(ctx); };
